import { FC } from 'react'
import Image from 'next/image'

import {
  ellipsePersonalizedBg,
  starbucksLogo,
  gamingIcon,
  heartSmileIcon,
  uberIcon,
  decorativeLinesSmall,
  checkmarkBlueIcon,
} from '@ui/assets'

export const PersonalizedEarning: FC = () => {
  return (
    <section
      id="earn-rewards"
      className="scroll-mt-20 overflow-hidden bg-[#0a3754] py-24"
    >
      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col gap-16 md:grid md:grid-cols-2 md:items-center">
          {/* Starbucks card - LEFT side on desktop, TOP on mobile */}
          <div className="relative h-auto min-h-[400px] md:h-[550px]">
            {/* Background ellipse */}
            <div className="absolute left-1/2 top-1/2 h-[300px] w-[250px] -translate-x-1/2 -translate-y-1/2 md:left-0 md:top-1/2 md:h-[420px] md:w-[350px] md:-translate-y-1/2 md:translate-x-0">
              <div className="rotate-[30deg]">
                <Image
                  src={ellipsePersonalizedBg}
                  width={350}
                  height={420}
                  alt=""
                />
              </div>
            </div>

            {/* Starbucks card */}
            <div className="absolute left-1/2 top-[20px] z-10 hidden -translate-x-1/2 flex-col items-center gap-1 rounded-2xl bg-white p-6 shadow-lg lg:left-[-50px] lg:top-[10px] lg:inline-flex lg:translate-x-0">
              <div className="mb-1 flex h-[70px] w-[70px] items-center justify-center p-3">
                <Image src={starbucksLogo} width="40" height="40" alt="" />
              </div>
              <p className="font-display text-[18px] tracking-[-0.36px] text-[#0a2d4a]">
                Starbucks
              </p>
              <p className="font-display text-[24px] tracking-[-0.48px] text-[#29bfed]">
                $40
              </p>
            </div>

            {/* Paid Gaming badge - bottom left */}
            <div className="absolute bottom-[180px] left-[15px] z-20 flex items-center gap-2 rounded-full bg-[#0053e2] px-4 py-2 shadow-lg md:hidden lg:bottom-[170px] lg:left-[-80px] lg:flex">
              <Image src={gamingIcon} width="24" height="24" alt="" />
              <p className="font-display text-[18px] tracking-[-0.36px] text-white">
                Paid Gaming
              </p>
            </div>

            {/* Your Matches badge - top right */}
            <div className="absolute right-[10px] top-[50px] z-20 flex items-center gap-2 rounded-full bg-[#34af46] px-4 py-2 shadow-lg md:right-0 md:top-[120px]">
              <Image src={heartSmileIcon} width="24" height="24" alt="" />
              <p className="font-display text-[18px] tracking-[-0.36px] text-white">
                Your Matches
              </p>
            </div>

            {/* Uber cashback card - bottom right */}
            <div className="absolute bottom-4 right-[35px] z-20 md:bottom-12 md:right-0">
              <div className="relative flex items-center gap-3 rounded-2xl bg-white px-3 py-3 shadow-lg">
                <Image src={uberIcon} width={62} height={62} alt="" />
                <p className="font-display pr-4 text-base text-[#0a2d4a]">
                  Get 3% cash back
                </p>
                {/* Decorative lines - top right corner outside */}
                <div className="absolute right-[-32px] top-[-12px] rotate-[-25deg] scale-x-[-1]">
                  <Image
                    src={decorativeLinesSmall}
                    width={32}
                    height={24}
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Text content - RIGHT side on desktop, BOTTOM on mobile */}
          <div className="max-w-[580px]">
            <h2 className="font-display mb-10 text-4xl leading-none tracking-[-1.52px] text-white md:text-6xl lg:text-[56px]">
              Earn <span className="text-[#2cceff]">Rewards</span>
            </h2>
            <p className="mb-10 max-w-[456px] text-[19px] leading-[1.4] text-white">
              Access earnings from the ATM app easily with withdrawals starting
              at $5. Earn from signup & cashback offers, games, surveys, and
              more.
              <br />
              <br />
              We are not a bank or a lender but we can help supplement your
              income and pay for the necessities when it matters most.
            </p>

            <div className="space-y-5">
              <div className="flex items-center gap-3 border-b border-white/20 pb-5">
                <Image src={checkmarkBlueIcon} width={24} height={22} alt="" />
                <p className="text-[18px] text-white">Earn up to $200/week</p>
              </div>

              <div className="flex items-center gap-3 border-b border-white/20 pb-5">
                <Image src={checkmarkBlueIcon} width={24} height={22} alt="" />
                <p className="text-[18px] text-white">
                  Cover groceries, gas, and bills with earnings
                </p>
              </div>

              <div className="flex items-center gap-3">
                <Image src={checkmarkBlueIcon} width={24} height={22} alt="" />
                <p className="text-[18px] text-white">Avoid overdraft fees</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
